export default __webpack_public_path__ + "static/media/unknownImage.3a58e024.png";